module.exports = __webpack_public_path__ + "static/assets/19dfc8be2610d73b4b7f5b9da823519e.jpg";